import React, {forwardRef, useImperativeHandle, useState} from "react";
import {IconClose, IconIndicatorBlue} from "../../Icon";
import {Modal, Spin} from "antd";
import {t} from "i18next";
import {IMPORT_FILE_MODE_LINKMODE} from "@/Const";

const DialogFileImportModeLoading = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onCloseDialog:onCloseDialog
    }))

    const onShowDialog = (szImportMode:any)=>{
        setIsShowDialog(true);
        if (szImportMode == IMPORT_FILE_MODE_LINKMODE){
            setInMode(t("In link mode"))
        }else{
            setInMode(t("InCopyMode"))
        }
    }
    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [inMode,setInMode] = useState('');

    return(
        <Modal centered={true} width='400px' bodyStyle={{height:'280px'}} open={isShowDialog} closable={false} closeIcon={<IconClose/>} onCancel={()=>setIsShowDialog(false)} footer={null}>
            <div className={'flex-column-center'} style={{height:'100%'}}>
                <Spin spinning={true} indicator={IconIndicatorBlue}/>
                <span className={'mt-12 font-family-semi-bold'} style={{fontSize:'18px'}}>{t("Importing file")+"..."}</span>
                <span className={'mt-2 font-family-semi-bold'} style={{fontSize:'18px',color:'#3670F7'}}>{inMode}</span>
                <span className={'mt-16'} style={{color:'var(--color-A49A9A)'}}>{t("YouCanChangeMode")}</span>
            </div>
        </Modal>
    )
})

export default DialogFileImportModeLoading;
































